import React from 'react'
import {CircularProgress, makeStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Button from "../Button";
import clsx from "clsx";

const useStyles = makeStyles(theme => ({
    progress: {
        marginLeft: theme.spacing()
    },
    contained: {
        color: theme.palette.text.button,
    },
    text: {
        color: theme.palette.primary.main,
    }
}))

function WorkableButton(
    {
        working,
        children,
        variant = 'contained',
        onClick,
        ...props
    }) {
    const classes = useStyles();
    return (
        <Button
            variant={variant}
            onClick={working ? (e)=> e.stopPropagation() : onClick}
            {...props}>
            {children}
            {working && <CircularProgress className={
            clsx(classes.progress, {
                [classes.contained] : variant === 'contained',
                [classes.text] : variant !== 'contained'
            })


            } size={20}/>}
        </Button>
    )
}

WorkableButton.propTypes = {
    working: PropTypes.bool,
    disabled: PropTypes.bool,
    tooltip: PropTypes.oneOfType([PropTypes.string, PropTypes.element, PropTypes.elementType]),
    hideTooltip: PropTypes.bool,
    color: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.oneOf([ 'text', 'outlined', 'contained']),
}

export default WorkableButton;